import BoardTabTextAndAssetComponent from "./board-tab-text-and-asset-component";
import BoardTabTextAndAssetConfig from "./board-tab-text-and-asset-config";
import BoardTabTextAndAssetAdvancedConfig from "./board-tab-text-and-asset-advanced-config";

export default {
  BoardTabTextAndAssetComponent,
  BoardTabTextAndAssetConfig,
  BoardTabTextAndAssetAdvancedConfig
};
